export function wordDiff(a, b) {
  const A = a.split(/(\s+)/), B = b.split(/(\s+)/);
  const n = A.length, m = B.length;
  if (n * m > 250000) return { before: [{ t: a, k: "del" }], after: [{ t: b, k: "add" }] };
  const dp = Array.from({ length: n + 1 }, () => new Int32Array(m + 1));
  for (let i = n - 1; i >= 0; i--) for (let j = m - 1; j >= 0; j--) dp[i][j] = A[i] === B[j] ? dp[i + 1][j + 1] + 1 : Math.max(dp[i + 1][j], dp[i][j + 1]);
  const before = [], after = [];
  let i = 0, j = 0;
  while (i < n && j < m) {
    if (A[i] === B[j]) { before.push({ t: A[i] }); after.push({ t: B[j] }); i++; j++; }
    else if (dp[i + 1][j] >= dp[i][j + 1]) before.push({ t: A[i++], k: "del" });
    else after.push({ t: B[j++], k: "add" });
  }
  while (i < n) before.push({ t: A[i++], k: "del" });
  while (j < m) after.push({ t: B[j++], k: "add" });
  return { before, after };
}

export const DiffText = ({ parts }) => (
  <>{parts.map((p, i) => <span key={i} className={p.k === "del" ? "bg-[#fbd5d2] line-through decoration-[#d1453b]" : p.k === "add" ? "bg-[#cdeedd]" : ""}>{p.t}</span>)}</>
);
